import { Component, OnInit, Input, forwardRef, Injector } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';

import { FieldBaseComponent } from 'src/app/shared/components/field-base/field-base.component';

@Component({
  selector: 'app-field-input-currency',
  templateUrl: './field-input-currency.component.html',
  styleUrls: ['./field-input-currency.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => FieldInputCurrencyComponent), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => FieldInputCurrencyComponent), multi: true }
  ],
})
export class FieldInputCurrencyComponent extends FieldBaseComponent implements OnInit {

  @Input() placeholder: string | null;

  constructor(
    protected injector: Injector,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

}
